export default __webpack_public_path__ + "static/media/modal.2c8574d4.svg";